import { ADP_CONFIG } from './constants/adp';
import { getAmendmentConfig } from './constants/amendment';
import { getAnnualReportConfig } from './constants/annualReport';
import { BANK_OF_AMERICA_CONFIG } from './constants/bankOfAmerica';
import { BASIC_EMAIL_CONFIG } from './constants/basicEmail';
import { BENEFICIAL_OWNERSHIP_FILING_CONFIG } from './constants/beneficialOwnershipFiling';
import { BUSINESS_CREDIT_CARDS_CONFIG } from './constants/businessCreditCard';
import { BUSINESS_KIT_CONFIG } from './constants/businessKit';
import { getBusinessLicensesConfig, BUSINESS_LICENSES_CONFIG_NEW } from './constants/businessLicense';
import { BUSINESS_LICENSE_FILING_CONFIG } from './constants/businessLicenseFiling';
import { CHANGE_OF_REGISTERED_AGENT_CONFIG } from './constants/changeOfregisteredAgent';
import { CONSTANT_CONTACT } from './constants/constantContact';
import { CORP_FORMATION_CONFIG } from './constants/corpFormation';
import { CORPORATE_BYLAWS_CONFIG } from './constants/corporateBylaws';
import { CORPORATE_DOCS_CONFIG } from './constants/corporateDocs';
import { DBA_ENTITY_CONFIG } from './constants/dbaEntity';
import { DOMAIN_NAME_REG_CONFIG } from './constants/domainNameReg';
import { EIN_CONFIG } from './constants/ein';
import { INITIAL_REPORT_CONFIG } from './constants/initialReport';
import { IPOSTAL1_CONFIG } from './constants/iPostal1';
import { LEGAL_SHIELD_CONFIG } from './constants/legalShield';
import { LLC_FORMATION_CONFIG } from './constants/llcFormation';
import { LOGO_KIT_CONFIG } from './constants/logoKit';
import { NEXT_INSURANCE_CONFIG } from './constants/nextInsurance';
import { NY_PUBLICATION_CONFIG } from './constants/nyPublication';
import { OCOYA_CONFIG } from './constants/ocoya';
import { OPERATING_AGREEMENT_CONFIG } from './constants/operatingAgreement';
import { QUARTERLY_TAX_PLANNING_CONFIG } from './constants/quarterlyTaxPlanning';
import { REGISTERED_AGENT_CONFIG } from './constants/registeredAgent';
import { S_CORP_BUNDLE } from './constants/sCorpBundle';
import { S_CORP_DESIGNATOR } from './constants/sCorpDesignator';
import { SHOPIFY_CONFIG } from './constants/shopify';
import { STANDARD_GOOD_STANDING_CONFIG } from './constants/standardGoodStanding';
import { STATIC_WEBSITE_CONFIG } from './constants/staticWebsite';
import { TAX_ADVICE_CONFIG } from './constants/taxAdvice';
import { TAX_FILING_CONFIG } from './constants/taxFiling';
import { TRADEMARKS_SEARCH_CONFIG } from './constants/trademark';
import { WEBSITE_TOOLS_BUNDLE_CONFIG } from './constants/websiteToolsBundle';
import { WFC_ADVANCED_CONFIG } from './constants/wfcAdvanced';
import { WFC_SERVICES_CONFIG } from './constants/wfcServices';
import { ZB_MONEY_PRO_CONFIG } from './constants/zbMoneyPro';

const landingPageConfigMapping = {
  adp: ADP_CONFIG,
  amendment: getAmendmentConfig,
  'annual-report': getAnnualReportConfig,
  'basic-email': BASIC_EMAIL_CONFIG,
  'beneficial-ownership-filing': BENEFICIAL_OWNERSHIP_FILING_CONFIG,
  'business-credit-card': BUSINESS_CREDIT_CARDS_CONFIG,
  'business-kit': BUSINESS_KIT_CONFIG,
  'business-licenses': getBusinessLicensesConfig,
  'business-license-report': BUSINESS_LICENSES_CONFIG_NEW,
  'business-license-filing': BUSINESS_LICENSE_FILING_CONFIG,
  'change-of-registered-agent': CHANGE_OF_REGISTERED_AGENT_CONFIG,
  'constant-contact': CONSTANT_CONTACT,
  'corp-formation': CORP_FORMATION_CONFIG,
  'corporate-bylaws': CORPORATE_BYLAWS_CONFIG,
  'corporate-docs': CORPORATE_DOCS_CONFIG,
  'dba-entity': DBA_ENTITY_CONFIG,
  'domain-name-reg': DOMAIN_NAME_REG_CONFIG,
  'ein-creation': EIN_CONFIG,
  'initial-report': INITIAL_REPORT_CONFIG,
  ipostal1: IPOSTAL1_CONFIG,
  'legal-shield': LEGAL_SHIELD_CONFIG,
  'llc-formation': LLC_FORMATION_CONFIG,
  'money-pro': ZB_MONEY_PRO_CONFIG,
  'next-insurance': NEXT_INSURANCE_CONFIG,
  'ny-publication': NY_PUBLICATION_CONFIG,
  ocoya: OCOYA_CONFIG,
  'operating-agreement': OPERATING_AGREEMENT_CONFIG,
  'registered-agent': REGISTERED_AGENT_CONFIG,
  'standard-good-standing': STANDARD_GOOD_STANDING_CONFIG,
  's-corp-bundle': S_CORP_BUNDLE,
  's-corp-designator': S_CORP_DESIGNATOR,
  shopify: SHOPIFY_CONFIG,
  'tax-advice': TAX_ADVICE_CONFIG,
  'quarterly-tax-planning': QUARTERLY_TAX_PLANNING_CONFIG,
  'tax-filing': TAX_FILING_CONFIG,
  'trademarks-search': TRADEMARKS_SEARCH_CONFIG,
  'website-tools-bundle': WEBSITE_TOOLS_BUNDLE_CONFIG,
  'wfc-advanced': WFC_ADVANCED_CONFIG,
  'wfc-services': WFC_SERVICES_CONFIG,
  'logo-kit': LOGO_KIT_CONFIG,
  'static-website': STATIC_WEBSITE_CONFIG,
  'bank-of-america': BANK_OF_AMERICA_CONFIG
};

// Get product details based on productId from the landing page configuration
const getProductDetails = (productId) => landingPageConfigMapping[productId];
export default getProductDetails;
